import { useTranslate } from '~/hooks/useTranslate.ts';
import { TimberbaseLogo } from '~/assets/svgs/GeneralIcons.tsx';
import { Button } from '~/components/ui';

export default function SignedOut() {
  const { t } = useTranslate();

  return (
    <div className="w-full min-h-screen bg-prim flex justify-center items-start pb-16 pt-20 px-4">
      <title>{t('auth.signin.title')}</title>
      <div className="w-[28rem]">
        <div className="flex flex-col items-center justify-center gap-2">
          <TimberbaseLogo />
          <h2 className="text-neut-bg-alt font-normal text-3xl sm:text-4xl lg:text-5xl leading-[48px]">
            Timberbase
          </h2>
          <p className="text-neut-0 font-normal text-base sm:text-lg leading-[28px] ">
            {t('auth.signin.timberbase-description')}
          </p>
        </div>

        <div className="bg-neut-bg-alt p-6 sm:p-8 md:p-10 rounded-[12px] flex flex-col mt-8 gap-6 shadow-neut-200 text-center">
          <div className="flex flex-col gap-2">
            <h3 className="text-neut-prim font-normal text-2xl leading-[32px]">
              {t('auth.logout.success')}
            </h3>
            <Button
              className="mt-4"
              onClick={() => {
                window.location.assign('/dashboard');
              }}
            >
              {t('auth.signin.again')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
